import { DEFAULT_EDITOR_ASSOCIATION } from '../../../common/editor.js';
var SettingValueType;
( (function(SettingValueType) {
    SettingValueType["Null"] = "null";
    SettingValueType["Enum"] = "enum";
    SettingValueType["String"] = "string";
    SettingValueType["MultilineString"] = "multiline-string";
    SettingValueType["Integer"] = "integer";
    SettingValueType["Number"] = "number";
    SettingValueType["Boolean"] = "boolean";
    SettingValueType["Array"] = "array";
    SettingValueType["Exclude"] = "exclude";
    SettingValueType["Include"] = "include";
    SettingValueType["Complex"] = "complex";
    SettingValueType["NullableInteger"] = "nullable-integer";
    SettingValueType["NullableNumber"] = "nullable-number";
    SettingValueType["Object"] = "object";
    SettingValueType["BooleanObject"] = "boolean-object";
    SettingValueType["LanguageTag"] = "language-tag";
    SettingValueType["ExtensionToggle"] = "extension-toggle";
})(SettingValueType || (SettingValueType = {})));
var SettingMatchType;
( (function(SettingMatchType) {
    SettingMatchType[SettingMatchType["None"] = 0] = "None";
    SettingMatchType[SettingMatchType["LanguageTagSettingMatch"] = 1] = "LanguageTagSettingMatch";
    SettingMatchType[SettingMatchType["RemoteMatch"] = 2] = "RemoteMatch";
    SettingMatchType[SettingMatchType["DescriptionOrValueMatch"] = 4] = "DescriptionOrValueMatch";
    SettingMatchType[SettingMatchType["KeyMatch"] = 8] = "KeyMatch";
})(SettingMatchType || (SettingMatchType = {})));
function validateSettingsEditorOptions(options) {
    return {
        ...options,
        override: DEFAULT_EDITOR_ASSOCIATION.id,
        pinned: true
    };
}
const DEFINE_KEYBINDING_EDITOR_CONTRIB_ID = 'editor.contrib.defineKeybinding';
const FOLDER_SETTINGS_PATH = '.vscode/settings.json';
const DEFAULT_SETTINGS_EDITOR_SETTING = 'workbench.settings.openDefaultSettings';
const USE_SPLIT_JSON_SETTING = 'workbench.settings.useSplitJSON';
export { DEFAULT_SETTINGS_EDITOR_SETTING, DEFINE_KEYBINDING_EDITOR_CONTRIB_ID, FOLDER_SETTINGS_PATH, SettingMatchType, SettingValueType, USE_SPLIT_JSON_SETTING, validateSettingsEditorOptions };
